import { computed } from "vue";
import { isDirectToCustomerFlow } from "@/apps/merchant3/helpers/checkoutFlows";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import MerchantFlags from "@/apps/merchant3/types/MerchantFlags";
import { store } from "@/shared-store";

const newOffersUi = computed(() => {
  return store.state.merchant?.merchantFlags?.includes(
    MerchantFlags.NEW_OFFERS_UI
  );
});

export const getOffersRouteName = ():
  | RouteName.DirectToCustomerOfferSummary
  | RouteName.M3PreparingOffersV2
  | RouteName.M3Offers => {
  return isDirectToCustomerFlow.value
    ? RouteName.DirectToCustomerOfferSummary
    : newOffersUi.value
    ? RouteName.M3PreparingOffersV2
    : RouteName.M3Offers;
};
